// Invitation, at the top of the Inbox, to turn on pop-up notifications on this device (until it is on,
// impossible, or dismissed). The switch itself lives in Impostazioni → Profilo e notifiche.
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BellRing, X } from 'lucide-react';
import { usePushStatus } from '../../api/queries.ts';
import { useOrgCtx } from '../../app/org-context.tsx';
import { currentSubscription, pushSupport } from '../../lib/push.ts';

const DISMISSED = 'unitly.pushPromptDismissed';

export function PushPrompt() {
  const { orgId, base } = useOrgCtx();
  const support = pushSupport();
  const [endpoint, setEndpoint] = useState<string | null | undefined>(support === 'supported' ? undefined : null);
  const [dismissed, setDismissed] = useState(() => { try { return localStorage.getItem(DISMISSED) === '1'; } catch { return false; } });
  const status = usePushStatus(orgId, support === 'unsupported' || dismissed ? undefined : endpoint);
  useEffect(() => {
    if (support === 'supported') void currentSubscription().then((s) => setEndpoint(s?.endpoint ?? null), () => setEndpoint(null));
  }, [support]);

  const denied = support === 'supported' && Notification.permission === 'denied';
  if (support === 'unsupported' || dismissed || denied || !status.data?.configured || status.data.subscribed) return null;
  const dismiss = () => { setDismissed(true); try { localStorage.setItem(DISMISSED, '1'); } catch { /* per-session only */ } };

  return (
    <div className="card push-prompt">
      <span className="push-prompt-icon"><BellRing size={18} /></span>
      <span className="grow">
        <strong>Notifiche anche con Unitly chiusa</strong>
        <small>{support === 'ios-install' ? 'Su iPhone: aggiungi Unitly alla schermata Home e attivale dall’app.' : 'Un avviso su questo dispositivo per assegnazioni, commenti e messaggi.'}</small>
      </span>
      <Link className="btn btn-primary btn-sm" to={`${base}/settings/profile`}>{support === 'ios-install' ? 'Come fare' : 'Attiva'}</Link>
      <button type="button" className="icon-btn muted" aria-label="Non ora" onClick={dismiss}><X size={16} /></button>
    </div>
  );
}
